import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActions: [
          'config/setConfig',
          'workflow/setCurrentStepProceedFn',
        ],
        // Ignore these paths in the state
        ignoredPaths: ['config', 'workflow'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type Dispatch = typeof store.dispatch;
